import React from "react";
import "../Spinner/Spinner.css"; 

const Spinner = () => {
  return (
    <div className="spinner-container">
      <span className="loading-text">✈️</span>
    </div>
  );
};

export default Spinner;
